import script from "./PartnerDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartnerDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./PartnerDashboard.vue?vue&type=style&index=0&id=ffeec518&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffeec518"]])

export default __exports__